
document.addEventListener("DOMContentLoaded", async () => {

    const wrapper = document.getElementById("wishlist-products");

    if (!wrapper) return;

    function getWishlist() {
        try {
            return JSON.parse(
                localStorage.getItem("wishlist") || "[]"
            );
        } catch (error) {
            return [];
        }
    }

    // Show empty wishlist message
    function showEmptyWishlist() {
        wrapper.innerHTML = `
            <p class="wishlist-empty">No wishlist items</p>
        `;
    }

    const wishlist = getWishlist();

    // If wishlist is empty, don't create Add All button
    if (wishlist.length === 0) {
        showEmptyWishlist();
        return;
    }

    // Create Add All button and product container
    wrapper.innerHTML = `
        <div id="wishlist-actions">
            <button type="button" id="add-all-to-cart">
                Add All to Cart
            </button>
        </div>

        <div id="wishlist-items"></div>
    `;

    const wishlistItems = document.getElementById("wishlist-items");

    // Load wishlist products
    for (const handle of wishlist) {
        try {
            const response = await fetch(
                `/products/${encodeURIComponent(handle)}.js`
            );

            if (!response.ok) continue;

            const product = await response.json();

            const image = product.images?.length
                ? product.images[0]
                : "";

           const firstVariant = product.variants?.[0];

const price = firstVariant
    ? (firstVariant.price / 100).toFixed(2)
    : "0.00";

            const variant = product.variants?.find(
                item => item.available
            );

            wishlistItems.insertAdjacentHTML("beforeend", `
                <div class="wishlist-card"
                     data-handle="${product.handle}">

                    <a href="/products/${product.handle}">
                        <img
                            src="${image}"
                            alt="${product.title.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;")}"
                        >
                    </a>

                    <h3>${product.title.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")}</h3>

                    <p>Tk ${price}</p>

                    <form action="/cart/add" method="post">
                        <input
                            type="hidden"
                            name="id"
                            value="${variant ? variant.id : ""}"
                        >

                        <input
                            type="hidden"
                            name="quantity"
                            value="1"
                        >

                        <button
                            type="submit"
                            class="wishlist-add-to-cart"
                            ${variant ? "" : "disabled"}
                        >
                            ${variant ? "Add to Cart" : "Sold Out"}
                        </button>

                        <button
                            type="button"
                            class="remove-wishlist"
                            data-handle="${product.handle}"
                        >
                            X
                        </button>
                    </form>

                </div>
            `);

        } catch (error) {
            console.error("Product loading error:", error);
        }
    }

    // Hide Add All button if no product cards were loaded
    function checkEmpty() {
        const currentWishlist = getWishlist();

        if (
            currentWishlist.length === 0 ||
            !wishlistItems.querySelector(".wishlist-card")
        ) {
            showEmptyWishlist();
            return true;
        }

        return false;
    }

    checkEmpty();

    // Remove wishlist product
    wrapper.addEventListener("click", event => {

        const button = event.target.closest(".remove-wishlist");

        if (!button) return;

        const handle = button.dataset.handle;

        const updatedWishlist = getWishlist().filter(
            item => item !== handle
        );

        localStorage.setItem(
            "wishlist",
            JSON.stringify(updatedWishlist)
        );

        button.closest(".wishlist-card")?.remove();

        // Last product removed: hide Add All button
        if (updatedWishlist.length === 0) {
            showEmptyWishlist();
        }
    });

    // Add all available products to cart
    wrapper.addEventListener("click", async event => {

        const button = event.target.closest("#add-all-to-cart");

        if (!button) return;

        const handles = getWishlist();

        if (handles.length === 0) {
            showEmptyWishlist();
            return;
        }

        button.disabled = true;
        button.textContent = "Adding Products...";

        try {
            const items = [];

            for (const handle of handles) {
                const response = await fetch(
                    `/products/${encodeURIComponent(handle)}.js`
                );

                if (!response.ok) continue;

                const product = await response.json();

                const variant = product.variants?.find(
                    item => item.available
                );

                if (variant) {
                    items.push({
                        id: variant.id,
                        quantity: 1
                    });
                }
            }

            if (items.length === 0) {
                button.textContent = "No Available Products";
                button.disabled = false;
                return;
            }

            const response = await fetch(
                `${window.Shopify.routes.root}cart/add.js`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify({ items })
                }
            );

            if (!response.ok) {
                throw new Error("Unable to add products to cart");
            }

            window.location.href =
                `${window.Shopify.routes.root}cart`;

        } catch (error) {
            console.error("Add all to cart error:", error);

            button.textContent = "Failed - Try Again";
            button.disabled = false;
        }
    });

});
